import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function StreetMapSection() {
    const { t } = useTranslation();
    const [isMapOpen, setIsMapOpen] = useState(false);

    return (
        <section id="street-map" className="relative w-full bg-bg-base py-16 md:py-24 border-t border-black/5 overflow-hidden">
            <div className="shell max-w-6xl mx-auto px-4 md:px-6">
                <div className="flex flex-col items-center">
                    
                    {/* Header */}
                    <div className="text-center mb-12">
                        <h2 className="text-2xl md:text-3xl font-serif text-secondary uppercase tracking-wider mb-3">
                            {t('schedule.street_map_title')}
                        </h2>
                        <div className="w-12 h-[1px] bg-primary/45 mx-auto mb-4" />
                    </div>

                    {/* Maps Side-by-Side Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-stretch w-full mb-12 max-w-4xl mx-auto">
                        
                        {/* Left Side: Custom Print Map Image (with zoom/lightbox) */}
                        <div className="flex flex-col justify-center items-center bg-white p-4 rounded-3xl border border-gray-100 shadow-sm group hover:shadow-md transition-shadow duration-300">
                            <div 
                                className="relative overflow-hidden rounded-2xl cursor-zoom-in w-full aspect-[1131/1600] bg-gray-50 flex items-center justify-center border border-gray-100"
                                onClick={() => setIsMapOpen(true)}
                            >
                                <img 
                                    src="/images/street_map_albacete.jpeg" 
                                    alt={t('schedule.street_map_title')}
                                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.02]"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors flex items-center justify-center">
                                    <span className="bg-[#4A3728]/95 text-white text-[10px] font-sans tracking-wider px-4 py-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-md uppercase font-bold">
                                        {t('schedule.zoom_map')}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Right Side: Interactive Google Map Iframe */}
                        <div className="flex flex-col justify-center items-center bg-white p-4 rounded-3xl border border-gray-100 shadow-sm">
                            <div className="w-full aspect-[1131/1600] overflow-hidden rounded-2xl border border-gray-100 shadow-inner">
                                <iframe
                                    src="https://maps.google.com/maps?q=Factory+Bar+La+Nena+Albacete&z=15&output=embed"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen={true}
                                    loading="lazy"
                                    title="Google Map Albacete"
                                    className="w-full h-full"
                                />
                            </div>
                        </div>

                    </div>

                    {/* Bottom Action Button: Clickable Link to Google Maps */}
                    <div className="flex justify-center mt-2">
                        <a 
                            href="https://maps.app.goo.gl/LTh4Rs5Bkw6aTh8A6?g_st=i"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent hover:bg-accent/90 text-white rounded-full font-display uppercase tracking-widest text-[11px] md:text-xs transition-all duration-300 shadow-md shadow-accent/15 hover:shadow-lg hover:-translate-y-0.5"
                        >
                            <svg 
                                className="w-4 h-4 fill-current" 
                                viewBox="0 0 24 24" 
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                            </svg>
                            {t('schedule.open_google_maps')}
                        </a>
                    </div>

                </div>
            </div>

            {/* Custom Map Lightbox Modal */}
            {isMapOpen && (
                <div 
                    className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/85 backdrop-blur-sm p-4 md:p-8 cursor-zoom-out animate-fade-in"
                    onClick={() => setIsMapOpen(false)}
                >
                    <div className="relative max-w-4xl max-h-[90vh] w-full flex flex-col items-center justify-center">
                        <button 
                            className="absolute top-[-48px] right-0 text-white hover:text-white/80 font-sans text-[11px] tracking-widest uppercase bg-[#4A3728]/70 hover:bg-[#4A3728]/90 transition-colors px-4 py-2 rounded-full border border-white/10"
                            onClick={() => setIsMapOpen(false)}
                        >
                            {t('schedule.close')}
                        </button>
                        <img 
                            src="/images/street_map_albacete.jpeg" 
                            alt={t('schedule.street_map_title')}
                            className="max-w-full max-h-[80vh] object-contain rounded-2xl shadow-2xl border border-white/10 cursor-default animate-slide-up"
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                </div>
            )}
        </section>
    );
}
